@if (withIcon()) {
  <app-icon name="check" size="sm" class="tw-align-top tw-h-[1.42857em] tw-items-center tw-mr-spacing-50" />
}
<span><ng-content/></span>
